cockpitApp.directive('automaticCheckin', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/automatic-checkin',
    controllerAs: 'detailAutomaticCheckinCtrl',
    controller: 'detailAutomaticCheckinController'
  };
});
